// extracted by mini-css-extract-plugin
module.exports = {"card":"index_card__3GB-X"};